import { createFileRoute, redirect } from '@tanstack/react-router';
import { buildHead } from '../../utils/seo';

export const Route = createFileRoute('/_layout/book-demo')({
  beforeLoad: () => {
    throw redirect({ to: '/build-demo' });
  },
  head: () => buildHead('/book-demo'),
});

